export default "__VITE_ASSET__w4Tr0uYj__"